import React, { forwardRef } from 'react'
import styled, { css } from 'styled-components'
import { useLocation, Link } from 'react-router-dom'
import { inheritPrimaryColor } from '../colors'

const NavBar = styled(forwardRef((props, ref) => {
  const { pathname } = useLocation()
  const newsActive = pathname.match(/^\/news/)
  const teamActive = pathname.match(/^\/team/)
  const researchActive = pathname.match(/^\/research/)
  const articlesActive = pathname.match(/^\/articles/)
  const resourcesActive = pathname.match(/^\/resources/)
  const homeActive = noneTrue(newsActive, teamActive, researchActive, articlesActive, resourcesActive)
  return (
    <div ref={ref} {...props}>
      <NavItem to='/' active={homeActive}>Home</NavItem>
      <NavItem to='/news' active={newsActive}>News</NavItem>
      <NavItem to='/team' active={teamActive}>Team</NavItem>
      <NavItem to='/research' active={researchActive}>Research</NavItem>
      <NavItem to='/resources' active={resourcesActive}>Resources</NavItem>
      {/* <NavItem to='/articles' active={articlesActive}>Articles</NavItem>*/}
    </div>
  )
}))`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background-color: ${inheritPrimaryColor};
`

const noneTrue = (...args) => {
  for (let item of args) {
    if (item) return false
  }
  return true
}

const NavItem = styled(Link)`
  padding: 35px;
  transition: color 0.2s, background-color 0.2s;
  cursor: pointer;
  font-size: 18px;
  color: white;
  text-decoration: none;
  &:hover {
    color: ${inheritPrimaryColor};
    background-color: white;
  }
  ${p => p.active
    ? css`
      background-color: white;
      color: ${inheritPrimaryColor};
    `
    : ''
  }
`

export default NavBar